<template>
  <div class="q-py-xl">
    <div class="text-center text-primary text-weight-bold" style="font-size: 2.75rem">
      Real-time data & analytics for your portfolio
    </div>
    <div class="text-center text-grey-7 q-mb-xl text-subtitle1">
      Leverage daily data and insights from more than 5 million multifamily properties and gain an
      edge on your competition
    </div>
  </div>
  <div class="subscribe-market-reports">
    <checkout-card
      plan-name="Regional Reports Add-On"
      :price="100"
      :trial-days="0"
      add-on
      @create-subscription="createSubscription"
    >
      <div class="q-mb-lg">
        <div class="q-gutter-sm">
          <div class="text-subtitle1 text-weight-medium text-grey-7">Activate Add-On</div>
          <div class="text-h3">$100/mo</div>
        </div>
        <div class="q-my-xl">
          Power your market surveys with
          <b>real-time data on over 35M multifamily units</b> nationwide, sourced entirely from
          property websites and public data sources.
        </div>
      </div>
    </checkout-card>
  </div>
</template>

<script lang="ts">
import { useStripeStore } from '@/stores/stripe'
import CheckoutCard from '@/components/CheckoutCard.vue'

export default {
  name: 'SubscribeMarketReportsView',
  components: {
    CheckoutCard
  },
  methods: {
    async createSubscription(payload: {
      paymentId: string
      couponId?: string
      cb: () => void
      failCb: () => void
    }) {
      const sub = await useStripeStore().createMarketReportsSubscription()
      if (sub) {
        payload.cb()
      } else {
        payload.failCb()
      }
    }
  }
}
</script>
<style scoped>
.subscribe-market-reports {
  max-width: 1280px;
  margin: auto;
}
</style>
